
import { SideNav } from "./SideNav";
import { BottomNav } from "@/components/BottomNav";
import { useLocation } from "react-router-dom";
import { usePlatform } from "@/contexts/PlatformContext";
import { MobileWebNav } from "./web/MobileWebNav";
import { useEffect } from "react";

interface MainLayoutProps {
  children: React.ReactNode;
  hideNav?: boolean;
}

export const MainLayout = ({ children, hideNav }: MainLayoutProps) => {
  const { isNativeApp, isMobileWeb, isDesktop } = usePlatform();
  const location = useLocation();
  
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isSellerRoute = location.pathname.startsWith('/seller');
  const isOnboardingRoute = location.pathname === '/onboarding';
  const isMapRoute = location.pathname === '/map';
  const isAuthRoute = location.pathname === '/auth' || location.pathname.startsWith('/auth');

  // Reset any Safari background color issues on main content mount
  useEffect(() => {
    document.body.style.backgroundColor = "";
    document.documentElement.style.backgroundColor = "";
    document.body.style.overflow = "auto";
  }, [location.pathname]);

  if (isOnboardingRoute || isMapRoute || isAdminRoute || isAuthRoute) {
    return <>{children}</>;
  }

  return (
    <div className="flex min-h-screen bg-background">
      {isDesktop && !hideNav && <SideNav />}
      
      <div className="flex-1 min-w-0">
        <main>
          {isMobileWeb && !hideNav && <MobileWebNav isSellerRoute={isSellerRoute} />}
          <div className={`${isMobileWeb ? "pt-16" : ""} ${isNativeApp && !hideNav ? 'pb-24' : 'pb-0'}`}>
            {children}
          </div>
          {isNativeApp && !hideNav && <BottomNav />}
        </main>
      </div>
    </div>
  );
};
